/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetAvailableEventActionNamesQuery } from "~/generated/graphql";

type Options = {
  skip?: boolean;
};

export function useGetAvailableEventActionNames(options?: Options) {
  const { data, loading, error } = useGetAvailableEventActionNamesQuery({
    fetchPolicy: "cache-and-network",
    skip: options?.skip,
  });

  return {
    data: data?.availableEventActionNames ?? [],
    loading,
    error,
  } as const;
}
